export const postDetailData = async (data) => {
    const reqData = JSON.stringify(data);

    let res
    try {
        res = await window.electronAPI.uploadData(data)
    } catch (error) {
        console.error('Error uploading file:', error);
    }
    return res
};


export const getHistory = async (startIndex, endIndex) => {
    let res
    try {
        const response = await window.electronAPI.getHistory(startIndex, endIndex)
        if (response.success) {
            res = response.data
        }  else {
            console.log("getHistory response", response)
        }
    } catch (error) {
        console.error('Error uploading file:', error);
    }

    return res
};

export const getHistoryDetail = async (id) => {
    let res
    try {
        res = await window.electronAPI.getHistoryDetail(id)
    } catch (error) {
        console.error('Error uploading file:', error);
    }
    return res
};
